var map = {
	"./1.3.0": 25193,
	"./1.3.0/": 25193,
	"./1.3.0/CrossChainDispatcher": 11697,
	"./1.3.0/CrossChainDispatcher.json": 11697,
	"./1.3.0/DebtToken": 81874,
	"./1.3.0/DebtToken.json": 81874,
	"./1.3.0/DepositToken": 86715,
	"./1.3.0/DepositToken.json": 86715,
	"./1.3.0/FeeProvider": 86137,
	"./1.3.0/FeeProvider.json": 86137,
	"./1.3.0/MerkleV2Abi": 43982,
	"./1.3.0/MerkleV2Abi.json": 43982,
	"./1.3.0/Pool": 73369,
	"./1.3.0/Pool.json": 73369,
	"./1.3.0/PoolRegistry": 3734,
	"./1.3.0/PoolRegistry.json": 3734,
	"./1.3.0/Quoter": 45205,
	"./1.3.0/Quoter.json": 45205,
	"./1.3.0/RewardsDistributor": 75063,
	"./1.3.0/RewardsDistributor.json": 75063,
	"./1.3.0/Swapper": 80652,
	"./1.3.0/Swapper.json": 80652,
	"./1.3.0/SyntheticToken": 81479,
	"./1.3.0/SyntheticToken.json": 81479,
	"./1.3.0/index": 25193,
	"./1.3.0/index.js": 25193,
	"./1.3.2": 58772,
	"./1.3.2/": 58772,
	"./1.3.2/CrossChainDispatcher": 96342,
	"./1.3.2/CrossChainDispatcher.json": 96342,
	"./1.3.2/DebtToken": 75691,
	"./1.3.2/DebtToken.json": 75691,
	"./1.3.2/DepositToken": 6467,
	"./1.3.2/DepositToken.json": 6467,
	"./1.3.2/FeeProvider": 32152,
	"./1.3.2/FeeProvider.json": 32152,
	"./1.3.2/MerkleV2Abi": 78607,
	"./1.3.2/MerkleV2Abi.json": 78607,
	"./1.3.2/Pool": 10913,
	"./1.3.2/Pool.json": 10913,
	"./1.3.2/PoolRegistry": 46835,
	"./1.3.2/PoolRegistry.json": 46835,
	"./1.3.2/Quoter": 42390,
	"./1.3.2/Quoter.json": 42390,
	"./1.3.2/RewardsDistributor": 10222,
	"./1.3.2/RewardsDistributor.json": 10222,
	"./1.3.2/Swapper": 76453,
	"./1.3.2/Swapper.json": 76453,
	"./1.3.2/SyntheticToken": 11482,
	"./1.3.2/SyntheticToken.json": 11482,
	"./1.3.2/index": 58772,
	"./1.3.2/index.js": 58772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4967;